<section class="section-background section-border">
  <table mat-table [dataSource]="dataSource">
    <!--- Note that these columns can be defined in any order.
      The actual rendered columns are set as a property on the row definition" -->

    <!-- Position Column -->
    <ng-container matColumnDef="roleType">
      <th mat-header-cell *matHeaderCellDef>Role</th>
      <td mat-cell *matCellDef="let element">
        {{ element?.nonSocType }}
      </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="representing">
      <th mat-header-cell *matHeaderCellDef>Firm Name</th>
      <td mat-cell *matCellDef="let element">
        {{
          element?.representing
        }}
      </td>
    </ng-container>

    <!-- Weight Column -->
    <ng-container matColumnDef="counsel">
      <th mat-header-cell *matHeaderCellDef>Counsel</th>
      <td mat-cell *matCellDef="let element">{{ element.counsel }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</section>
